<template>
  <v-footer
    dark
    height="auto"
  >
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-title class="primary darken justify-center">
        <strong class="subheading text-xs-center" ></strong>
        <span class="pa-5 text-xs-center">
          All rights reserved.
        </span>
      </v-card-title>
      <v-card-actions class="primary justify-center">
        {{ date }} &copy; <strong> Dr. Maen K Househ<sup>®</sup></strong>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>
<script>
  export default {
    data: () => ({
      date: new Date().toISOString().substr(0, 4),
    })
  }
</script>
<style>
.customBackF {
  background-color: #5eb600;
}
.customBackFa {
  background-color: #4e4a3d;
}
</style>
